import axios from 'axios'
// import store from "@/store";

export default {
    state: {
        notifications: [],
        notificationDestroy: []
    },
    getters: {
        notifications(state) {
            return state.notifications;
        },
        notificationDestroy(state) {
            return state.notificationDestroy;
        },
    },

    actions: {
        async getNotifications({ commit }) {
            const res = await axios.get("notifications");

            const data = res && res.data && res.data.data && res.data.data.data;
            commit("setNotifications", data);
        },

        async notificationDestroy({ commit }, payload) {
            const res = await axios.post("notification/destroy", payload);
            // store.commit("setIsSuccess",  res && res.data && res.data.message);

            const data = res && res.data && res.data.data;
            commit("setNotificationDestroy", data);
        },
    },
    mutations: {
        setNotifications(state, data) {
            state.notifications = data;
        },
        setNotificationDestroy(state, data) {
            state.notificationDestroy = data;
        },
    }
}